module.exports = __webpack_public_path__ + "img/propertyIndexTab1.0527085d.png";